import React from 'react';
import '../styles/BlogStyles/BlogStyles.css';
import { Link } from 'react-router-dom';
import bloglist from "../assets/blog.jpeg";


const BlogList = () => {
  const blogPosts = [
    {
      id: 1,
      title: "Go Global with Your Career – CPA, CMA (US) & EA Courses at Madhi Academy",
      desc: "Go Global with Your Career – CPA, CMA (US) & EA Courses at Madhi Academy In today’s competitive job market,...",
      img: "https://i.pinimg.com/1200x/b2/bc/92/b2bc92a31054fa6117dd8e9a2885e71a.jpg",
      link: "/blog/ca-results-announced"
    },
  
  ];

  return (
    <div className="blog-page-wrapper">
      
      {/* 1. Hero Section */}
      <section className="blog-hero position-relative">
        <img 
          src={bloglist} 
          alt="Blog Header" 
          className="w-100 img-fluid blog-hero-img"
        />
        <div className="blog-hero-overlay"></div>
      </section>

      {/* 2. Blog Post Grid */}
      <section className="container py-5">
        <div className="row g-4 justify-content-center"> 
          
          {blogPosts.map((post) => (
            /* CHANGE: col-lg-4 creates 3 columns per row on large screens */
            <div key={post.id} className="col-12 col-md-6 col-lg-4"> 
              
              <div className="card h-100 custom-blog-card">
                {/* Image Wrapper */}
                <div className="card-img-wrapper">
                  <img 
                    src={post.img} 
                    alt={post.title} 
                    className="blog-card-img"
                  />
                </div>
                
                {/* Card Body */}
                <div className="card-body px-0 pb-0 d-flex flex-column">
                  <h5 className="card-title fw-bold text-dark mb-3">
                    {post.title}
                  </h5>
                  <p className="card-text text-muted mb-4 line-clamp-3">
                    {post.desc}
                  </p>
                  
                  {/* Button pushes to bottom */}
                  <div className="mt-auto">
                    <Link to={post.link} className="btn btn-purple">
                      Read More
                    </Link>
                  </div>
                </div>
              </div>

            </div>
          ))}

        </div>
      </section>

    </div>
  );
};

export default BlogList;